module.exports = __webpack_public_path__ + "img/AE5007-163.3677584b.jpg";